import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/computer-device-mobile-tablet-touch.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M237.33 106.21 61.41 41l-.16-.05a16 16 0 0 0-20.35 20.3 1 1 0 0 0 .05.16l65.26 175.92A15.77 15.77 0 0 0 121.28 248h.3a15.77 15.77 0 0 0 15-11.29l.06-.2 21.84-78 78-21.84.2-.06a16 16 0 0 0 .62-30.38Zm-87.49 38.09a8 8 0 0 0-5.54 5.54l-23 82.16-.06-.17L56 56l175.82 65.22.16.06Z" }, null, -1)])]);
}
var computer_device_mobile_tablet_touch_default = { render };
//#endregion
export { computer_device_mobile_tablet_touch_default as default, render };

//# sourceMappingURL=computer-device-mobile-tablet-touch.svg.js.map